import { type PrePlanningDetail, useInspirationDetails } from "@repo/api";
import { Button, Tab, TabPanel, Tabs } from "@repo/skapa";
import { t } from "@repo/translation";
import { ModalSheet, PaddedContainer } from "@repo/ui";

import { InspirationArticles } from "./InspirationArticles";
import { InspirationDetails } from "./InspirationDetails";
import { useInspirationActions } from "./InspirationItem";

interface InspirationModalProps {
  isOpen: boolean;
  closeModal: () => void;
  inspiration?: PrePlanningDetail;
}

export const InspirationModal = ({
  isOpen,
  closeModal,
  inspiration,
}: InspirationModalProps) => {
  const { data } = useInspirationDetails(inspiration);
  const actions = useInspirationActions(inspiration);

  if (!inspiration) {
    return null;
  }
  return (
    <ModalSheet
      title={t("label.inspiration")}
      visible={isOpen}
      onClose={closeModal}
      footer={actions.map((action) => (
        <Button
          key={`inspiration-modal-footer__${action.id}`}
          text={action.text}
          onClick={action.onClick}
          type={action.modalType}
        />
      ))}
    >
      <Tabs
        tabs={[
          <Tab
            key="drawing-details-tab"
            text={t("label.details")}
            tabPanelId="drawing-details"
          />,
          <Tab
            key="drawing-items-tab"
            text={t("label.articles")}
            tabPanelId="drawing-items"
          />,
        ]}
        tabPanels={[
          <TabPanel key="drawing-details-tab" tabPanelId="drawing-details">
            <PaddedContainer>
              <InspirationDetails data={data} />
            </PaddedContainer>
          </TabPanel>,
          <TabPanel key="drawing-items-tab" tabPanelId="drawing-items">
            <InspirationArticles
              articles={data?.pricingProducts}
              id={inspiration.sourceId}
            />
          </TabPanel>,
        ]}
      />
    </ModalSheet>
  );
};
